import { render, staticRenderFns } from "./SosColorPicker.vue?vue&type=template&id=3e50678c&scoped=true&lang=pug"
import script from "./SosColorPicker.vue?vue&type=script&lang=js"
export * from "./SosColorPicker.vue?vue&type=script&lang=js"
import style0 from "./SosColorPicker.vue?vue&type=style&index=0&id=3e50678c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e50678c",
  null
  
)

export default component.exports